import React from 'react';

// ENUM
import { AlertType } from '../../enums/alert';

// ENUM
import { IAlert } from '../../interfaces/Alert.interface';

// STYLES
import { Container, Label, Link, Section, Span } from './styles';

const Alert: React.FC<IAlert> = ({
  actionLabel,
  badge: Badge,
  cardType,
  children,
  icon: Icon,
  isButtonBlock = false,
  label,
  onClick,
  pendencyContent,
  size,
  style,
  textType,
  type = AlertType.DEFAULT
}: IAlert) => {
  return (
    <Container type={type} hasBadge={!!Badge} size={size} style={style}>
      <section>{Icon}</section>

      <Section cardType={cardType}>
        {label && (
          <Label cardType={cardType} size={size} hasBadge={!!Badge}>
            {label}
          </Label>
        )}

        <Span size={size} textType={textType} type={type} cardType={cardType}>
          <div>{children}</div>
          {onClick && (
            <div>
              <Link isButtonBlock={isButtonBlock} onClick={onClick} size={size} type={type} cardType={cardType}>
                {actionLabel}
              </Link>
            </div>
          )}
        </Span>
        {Badge}
      </Section>
      {pendencyContent}
    </Container>
  );
};

export default Alert;
